<p class="table-title">בדיקת תכנון המערכת:</p>
<ol class="inspections">
  <li>
    <span class="inspection-item">תכנון:</span>
    <ol class="inspection-items">
      <li>
        <span class="case">פרטי המתכנן:</span>
        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 20%">
                <strong>שם המתכנן</strong>
              </th>
              <th style="width: 15%">
                <strong>טלפון</strong>
              </th>
              <th style="width: 35%">
                <strong>מייל</strong>
              </th>
              <th style="width: 30%">
                <strong>כתובת</strong>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <span>{{ planner?.name }}</span>
              </td>
              <td>
                <span>{{ planner?.phone }}</span>
              </td>
              <td>
                <span>{{ planner?.email }}</span>
              </td>
              <td>
                <span>{{ planner?.address }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </li>
      <li>
        <span class="case">רשימת התוכניות והמסמכים:</span>
        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 30%"><span>שם התוכנית</span></th>
              <th style="width: 12%"><span>קוד זיהוי</span></th>
              <th style="width: 12%"><span>מהדורה</span></th>
              <th style="width: 10%"><span>תאריך</span></th>
              <th style="width: 36%"><span>הערות</span></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!inspection?.planningDetails?.plans?.length">
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
              <td>&nbsp;</td>
            </tr>
            <tr *ngFor="let plan of inspection?.planningDetails?.plans">
              <td>
                <span>{{ plan.name }}</span>
              </td>
              <td>
                <span>{{ plan.identificationCode }}</span>
              </td>
              <td>
                <span>{{ plan.edition }}</span>
              </td>
              <td>
                <span>{{ plan.date | date : 'shortDate' : 'GMT+3' }}</span>
              </td>
              <td>
                <span>{{ plan.notes }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </li>
      <li>
        <span class="case">תפוסת הסיכון שנקבעה ע"י המתכנן:</span>
        <table class="data-table">
          <thead>
            <tr>
              <th style="width: 30%">רמת סיכון</th>
              <th style="width: 10%; text-align: center">סמן &#10004;</th>
              <th style="width: 60%">אזורי ההתקנה</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of inspection?.sprinklerSystemDesign?.main
                  ?.structureRisks?.riskLevels
              "
            >
              <td>
                <span>{{ item.level }}</span>
              </td>
              <td style="text-align: center">
                <span *ngIf="item.selected">&#10004;</span>
              </td>
              <td>
                <span>{{ item.installationArea }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </li>
      <li style="page-break-inside: avoid">
        <span class="case">הערות נוספות ותנאים לתכנון המערכת: </span>
        <ol class="notes">
          <li>
            <strong
              >בדיקת התכנון מתיחסת לתוכניות ולפירוט תפוסת הסיכון, כפי שמתואר
              בטבלאות לעיל.</strong
            >
          </li>
          <li *ngFor="let note of notes">
            <!-- <strong style="unicode-bidi: bidi-override">{{ note }}</strong> -->
            <strong>{{ note }}</strong>
          </li>
          <li
            *ngFor="
              let item of inspection?.summaryNotes
                | filterBy : ['addNotesToReport'] : true
            "
          >
            <strong>{{ item.notes }}</strong>
            <ol class="notes">
              <li
                *ngFor="
                  let subNote of item.subNotes
                    | filterBy : ['addNotesToReport'] : true
                "
              >
                <strong style="display: table-cell">{{ subNote.notes }}</strong>
              </li>
            </ol>
          </li>
        </ol>
        <section>
          <ng-content></ng-content>
        </section>
      </li>
    </ol>
  </li>
</ol>
